<!--既往外科手术治疗-->
<!-- 更名脾切除手术治疗 -->
<script setup>
import { computed, reactive, watch,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0

// 定义组件属性
const props = defineProps({
  formModel: {},
  prefix: "",
  type: null
});
//prefix
let attrs = ref('【'+ (notScreen.value?'补充':'既往') +'脾切除手术治疗】')


// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();

let title = ref(attrs.value.replace("【", "").replace("】", ""))

// const title = computed(() => {
//   if (props.prefix) {
//     return props.prefix.replace("【", "").replace("】", "");
//   } else {
//     return "";
//   }
// });

const isVisible = computed(() => {
  let result = {};
  // 单选的选择
  [`${attrs.value}受试者是否进行过${title.value}_是`].forEach((field) => {
    const key = field.split("_")[0];
    const value = field.split("_")[1];
    result[field] = model.fields[props.type][key] === value;
  });

  return result;
});

// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});
// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
    <!-- <p>----{{ attrs }}--{{title}}--</p> -->
    <h3>{{ title }}或脾栓塞</h3>
    <el-form-item label="是否适用肝筛选期脾切除手术治疗或脾栓塞数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['脾切除手术治疗或脾栓塞是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
      <template v-if="crfFields['脾切除手术治疗或脾栓塞是否适用肝筛选期数据'] == '否' || !isv0">

        <el-form-item :label="'是否' + (notScreen?'新增':'') + title + '或脾栓塞'" class="redStar pleft">
          <el-radio-group v-model="crfFields[`${attrs}受试者是否进行过${title}`]"> 
            <el-radio label="是" prop="是"></el-radio>
            <el-radio label="否" prop="否"></el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="isVisible[`${attrs}受试者是否进行过${title}_是`]">
            <el-form-item class="redStar pleft4"  label="手术名称" :prop="itemProp(`${attrs}手术名称`)" :rules="crfStore.radioRules('手术名称')">
              <!-- <el-input v-model="crfFields[`${props.prefix}手术名称`]" placeholder="请输入手术名称"></el-input> -->
              <el-radio-group v-model="crfFields[`${attrs}手术名称`]">
                <el-radio label="单纯脾切除" prop="单纯脾切除"></el-radio>
                <el-radio label="联合分流术" prop="联合分流术"></el-radio>
                <el-radio label="联合断流术" prop="联合断流术"></el-radio>
                <el-radio label="脾栓塞" prop="脾栓塞"></el-radio>
                <el-radio label="无" prop="无"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手术日期" class="redStar pleft4" :prop="itemProp(`${attrs}手术日期`)" :rules="crfStore.dateRules('手术日期')">
              <el-date-picker v-model="crfFields[`${attrs}手术日期`]"
                              type="date" placeholder="选择手术日期"
                              value-format="YYYY-MM-DD" />
            </el-form-item>
        </template>
      </template>
  </template>
</template>

<style scoped>
</style>